import { parse as nodeParseQueryString } from 'querystring';

let parsedQueryString: Record<string, string> | null = null;
let sourceParam: string | undefined = undefined;

export function getQueryStringParameters(locationObj: Pick<Location, 'search'> = location) {
    if (locationObj === location) {
        // Cache the parsed value for the main window
        return parsedQueryString || (parsedQueryString = parseQuery(location));
    } else {
        // Parsing the querystring for an iframe or such
        return parseQuery(locationObj);
    }
}

export function getQueryStringParameter(
    key: string,
    locationObj?: Pick<Location, 'search'>
): string {
    return getQueryStringParameters(locationObj)[key];
}

export function hasQueryStringParameter(key: string, locationObj?: Pick<Location, 'search'>) {
    return Object.prototype.hasOwnProperty.call(getQueryStringParameters(locationObj), key);
}

function parseQuery(locationObj: Pick<Location, 'search'>) {
    if (typeof locationObj !== 'undefined') {
        return locationObj.search ? nodeParseQueryString(locationObj.search.substr(1)) : {};
    }

    // We're running outside a browser window, so return an empty property bag
    return {};
}

let isGulpingValue = hasQueryStringParameter('gulp');
export function isGulping(): boolean {
    return isGulpingValue;
}

let isBranchingValue = hasQueryStringParameter('branch');
export function isBranching(): boolean {
    return isBranchingValue;
}

export function isGulpOrBranching() {
    return isGulpingValue || isBranchingValue;
}

export function getSourceQueryParam(): string | undefined {
    return sourceParam || (sourceParam = getAndStripSourceQueryParam());
}

function getAndStripSourceQueryParam(): string | undefined {
    let source = getQueryStringParameter('source');
    if (source) {
        const newSearch = removeQuery(location.search, 'source');
        history.replaceState(history.state, '/', location.pathname + newSearch);
    }
    return source;
}

function removeQuery(search: string, queryKey: string) {
    const regex = new RegExp('(\\?|&)' + queryKey + '=\\w*&?', 'g');
    let newSearch = search.split(regex).join('');
    const lastChar = newSearch[newSearch.length - 1];
    if (lastChar === '?' || lastChar === '&') {
        newSearch = newSearch.substr(0, newSearch.length - 1);
    }
    return newSearch;
}
